import { memo, useState } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'types';
import { useWindowEvent } from 'utils/hooks/useWindowEvent';
import { isTestWidgetOn, setTestWidgetOn } from 'app/components/TestWidgetHost';
import { TestUsersPicker } from 'app/components/TestWidgetHost/TestUsersPicker';
import { DraggableWindow } from 'app/components/AtomComponents/DraggableWindow';

export const TestWidgetLauncher = memo(function TestWidgetLauncher() {
  const businessId = useSelector((s: RootState) => s.authPage?.business?.id);
  const employeeId = useSelector(
    (s: RootState) => s.authPage?.currentEmployee?.id,
  );
  const [panelOpen, setPanelOpen] = useState<boolean>(false);

  useWindowEvent('keydown', e => {
    const hit =
      e.altKey && e.shiftKey && !e.ctrlKey && !e.metaKey && e.code === 'KeyW';
    if (!hit) return;
    e.preventDefault();
    if (isTestWidgetOn()) {
      setTestWidgetOn(false);
      setPanelOpen(false);
    } else if (businessId && employeeId) {
      setTestWidgetOn(true);
      setPanelOpen(true);
    }
  });

  if (!panelOpen) return null;

  return (
    <DraggableWindow
      title='Test users'
      onClose={() => setPanelOpen(false)}
      storageKey='heltar:test-widget-panel'
      initialPosition='bottom-left'
      defaultWidth={320}
      defaultHeight={260}
      minWidth={280}
      minHeight={160}
      closeOnEsc={false}
      zIndex={2147483000}
      contentClassName='p-3'
    >
      <TestUsersPicker businessId={businessId} employeeId={employeeId} />
    </DraggableWindow>
  );
});
